import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, useMap, GeoJSON, Popup } from 'react-leaflet';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import LoadingBox from "components/LoadingBox";
import parse from 'html-react-parser';
import "assets/css/map.css";
import L from 'leaflet'
import MapaLeafletRota from 'components/Map/MapaLeafletRota';
import MarkerClusterGroup from 'react-leaflet-markercluster';

export default function MapaLeaflet(props) {
    const {
        showLoading,
        centerMap,
        zoomMap,
        markers,
        polygon,
        markerCluster
    } = props;

    const [modalOpen, setModalOpen] = useState(false);
    const [itemDetail, setitemDetail] = useState(null);
    const ChangeMap = ({ center, zoom }) => {
        const mapInstance = useMap();
        mapInstance.setView(center, zoom);
        return null;
    }

    const DetailMarker = (_marker) => {
        if (_marker.enableClick) {
            if (_marker.tipoDetail == "Modal Mapa") {
                setitemDetail(_marker);
                setModalOpen(true);
            }
            else if (_marker.tipoDetail != "Html") {
                window.open(_marker.urlDetailMarker, '_blank');
            }
        }
    }

    const handleIcon = (icon) => {
        if (icon == null){
            return new L.Icon({
                iconUrl: require('assets/img/icons/point.png'),
                iconRetinaUrl: require('assets/img/icons/point.png')
            });
        }
        else{
            return new L.Icon({
                iconUrl: require('assets/img/icons/' + icon + '.png'),
                iconRetinaUrl: require('assets/img/icons/' + icon + '.png')
            });
        }        
    }

    return (
        <>
            <div id="map">
                <div className="useloading">
                    <MapContainer style={{ zIndex: "0", height: "90vh" }}>
                        <ChangeMap center={centerMap} zoom={zoomMap}></ChangeMap>
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        />
                        {markerCluster &&
                            <MarkerClusterGroup key={Math.random()}>
                                {markers != null && markers.map((item, key) => (<Marker key={key} position={[item.lat, item.lng]} icon={handleIcon(item.icon)} eventHandlers={{ click: () => DetailMarker(item) }}>
                                    {item.detailPopup && <Popup>{parse(item.detailPopup)}</Popup>}
                                </Marker>))}
                            </MarkerClusterGroup>
                        }
                        {!markerCluster &&
                            markers != null && markers.map((item, key) => (<Marker key={key} position={[item.lat, item.lng]} icon={handleIcon(item.icon)} eventHandlers={{ click: () => DetailMarker(item) }}>
                                {item.detailPopup && <Popup>{parse(item.detailPopup)}</Popup>}
                            </Marker>))
                        }
                        {polygon && <GeoJSON key={polygon} data={JSON.parse(polygon)} style={{ color: "gray" }}></GeoJSON>}
                        {showLoading && <LoadingBox />}
                    </MapContainer>
                </div>
            </div>
            <Modal isOpen={modalOpen} centered toggle={() => setModalOpen(false)} size="lg">
                <ModalHeader
                    toggle={() => setModalOpen(false)}
                    close={<button className="close" onClick={() => setModalOpen(false)}>&times;</button>}
                    className="md-hd">Rota do Veículo
                </ModalHeader>
                <ModalBody className="md-bd">
                    <MapaLeafletRota item={itemDetail}></MapaLeafletRota>
                </ModalBody>
            </Modal>
        </>
    )
}